.time-navigation-leg {
  position: relative;
  display: grid;
  grid-auto-flow: column;
  gap: 0.25rem;

  padding: 0.375rem;
  margin-right: 0.75rem;

  overflow-x: scroll;
  overflow-y: clip;

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  scroll-snap-type: x mandatory;

  overscroll-behavior-x: contain;

  &--left {
    direction: rtl;
    margin-right: 0;
    margin-left: 0.75rem;

    button {
      direction: ltr;
    }
  }

  button {
    scroll-snap-align: center;
  }
}
